/**
 * 将提交记录按批次分组（同一部门、同一数据类型、同一提交时间、同一状态）
 *
 * 批次key：部门ID + 数据类型 + 提交者ID + 提交时间（精确到秒）+ 状态 + 审核时间（如果有）
 * 对于已审核的记录，审核时间也作为批次key的一部分，确保不同时间审核的记录分开显示
 *
 * @param {Array} subs - 提交记录数组
 * @returns {Array} 分组后的批次数组，按提交时间降序排列
 */
export function groupSubmissionsByBatch(subs) {
  const batches = {};

  subs.forEach(sub => {
    const submittedAt = sub.submitted_at ? new Date(sub.submitted_at) : null;
    const reviewedAt = sub.reviewed_at ? new Date(sub.reviewed_at) : null;
    const status = sub.status || 'pending';

    const fmtTime = (dt) =>
      `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}_${String(dt.getHours()).padStart(2, '0')}-${String(dt.getMinutes()).padStart(2, '0')}-${String(dt.getSeconds()).padStart(2, '0')}`;

    let batchKey;
    if (submittedAt) {
      const timeStr = fmtTime(submittedAt);
      if (reviewedAt && (status === 'approved' || status === 'rejected')) {
        batchKey = `${sub.department_id}_${sub.data_type}_${sub.submitted_by || 'unknown'}_${timeStr}_${status}_${fmtTime(reviewedAt)}`;
      } else {
        batchKey = `${sub.department_id}_${sub.data_type}_${sub.submitted_by || 'unknown'}_${timeStr}_${status}`;
      }
    } else {
      if (reviewedAt && (status === 'approved' || status === 'rejected')) {
        batchKey = `${sub.department_id}_${sub.data_type}_${sub.submitted_by || 'unknown'}_no_time_${status}_${fmtTime(reviewedAt)}`;
      } else {
        batchKey = `${sub.department_id}_${sub.data_type}_${sub.submitted_by || 'unknown'}_no_time_${status}`;
      }
    }

    if (!batches[batchKey]) {
      batches[batchKey] = {
        key: batchKey,
        department_id: sub.department_id,
        data_type: sub.data_type,
        submitted_by: sub.submitted_by,
        submitted_by_username: sub.submitted_by_username,
        submitted_at: sub.submitted_at,
        status: status,
        submissions: [],
        ids: [],
      };
    }
    batches[batchKey].submissions.push(sub);
    batches[batchKey].ids.push(sub.id);
  });

  Object.values(batches).forEach(batch => {
    batch.submissions.sort((a, b) => (a.id || 0) - (b.id || 0));
    batch.ids.sort((a, b) => a - b);
  });

  return Object.values(batches).sort((a, b) => {
    if (a.submitted_at && b.submitted_at) {
      return new Date(b.submitted_at) - new Date(a.submitted_at);
    }
    if (a.submitted_at) return -1;
    if (b.submitted_at) return 1;
    return 0;
  });
}
